import React from "react";
import { useDispatch } from "react-redux";
import { cleanSearchingUsersPaginated, startSearchingUsersPaginated, userCleanSearchText, userSetSearchText } from "../../app/actions/userActions";

import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackComponent = ({ searchText, setSearchText, itemsPerPage }) => {
  debugLogPages(":: SearchBackComponent");
  
  const dispatch = useDispatch();
  const { t } = useTranslation();

  /*
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(startSearchingUsers(searchText));
    }, 500)

    return () => clearTimeout(timer)
  }, [searchText, dispatch])
  */

  const onChangeInput = (event) => {
    
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      dispatch(userSetSearchText(event.target.value));

      dispatch(startSearchingUsersPaginated(event.target.value, 0, itemsPerPage));
      
    } else {
      
      dispatch(cleanSearchingUsersPaginated());

      dispatch(userCleanSearchText);

    }
  };

  return (
    <div className="row d-flex justify-content-center align-items-center">
      <div className="col-md-12">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackComponent;
